<template>
  <range
    :label="$t('edit.sidebar.height')"
    min="50"
    max="150"
    step="1"
    :value="value()"
    :change="onChange"
    :move="onMove"
  ></range>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Range from '../../../general/Range.vue';

const defaultValue = 70;

export default {
  components: {
    Range,
  },
  methods: {
    value() {
      if (!this.boxConfig.trigger_button.style.height) {
        return defaultValue;
      }

      return this.boxConfig.trigger_button.style.height.replace('px', '');
    },
    onChange(value) {
      this.boxUpdateConfigStyle({
        item: 'trigger_button',
        rule: 'height',
        value: `${value}px`,
      });
    },
    onMove(value) {
      this.boxPreviewConfigStyleChange({
        item: 'trigger_button',
        rule: 'height',
        value: `${value}px`,
      });
    },
    ...mapActions([
      'boxUpdateConfigStyle',
      'boxPreviewConfigStyleChange',
    ]),
  },
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Height.vue?20ce4e7b
 **/